import $ from 'jquery'

// simple helper to deal with data-behavior
// in the file, we scope all behaviors within the `admin-market` behavior
// reducing the length needed of behavior name in both html and js
const amBehavior = function (value, global) {
  if (global) {
    return amBehavior('admin-market') + ' ' + amBehavior(value)
  } else {
    return "[data-behavior~='" + value + "']"
  }
}

$(document).on(
  'keyup keypress',
  amBehavior('admin-market') + " [data-behavior~='text-filter']",
  function (event) {
    const keyCode = event.keyCode || event.which
    if (keyCode === 13) {
      event.preventDefault()
      return false
    }
  }
)

$(document).on('click', amBehavior('tab', true), function () {
  const $tab = $(this)

  // unselect all tabs
  $(amBehavior('tab')).removeClass('active')

  // hide all tab contents
  $(amBehavior('tab-content')).hide()

  // figure out which tab content should be visible
  const tabContentId = $tab.data('target')

  // select the current tab
  $tab.addClass('active')

  // show the proper content tab
  $('#' + tabContentId).show()
})

$(document).on('click', amBehavior('toggle', true), function (event) {
  event.preventDefault()

  // locate current tab-content, so we can easily find
  // the two proper lists for moving item around
  const $tabContent = $(this).closest(amBehavior('tab-content'))

  // we find the element that's gonna move from one list to the other
  const parent = $(this).closest(amBehavior('block'))
  const checkedEl = parent.find('input[type=checkbox]')
  const checked = checkedEl.prop('checked')

  parent.find(amBehavior('add-link')).toggleClass('hidden')
  parent.find(amBehavior('remove-link')).toggleClass('hidden')
  parent.find(amBehavior('added-icon')).toggleClass('hidden')
  checkedEl.prop('checked', !checked)

  // we must find the proper tab, the counter is there, not
  // in the current tab-content, but since both share the ID
  // we can easily recover it thru it
  // tab          -> data-target="1234"
  // tab-content  -> id="1234"
  const tabId = $tabContent.attr('id')

  const $tab = $(amBehavior('tab') + '[data-target=' + tabId + ']')
  const $addedList = $tabContent.find(amBehavior('added-list'))
  const usedCounteEl = $tab.find(amBehavior('count'))
  const usedTemplatesCount = parseInt(usedCounteEl.html())

  // now we move the element to the other list depending on where it was
  // and we change various aspect of it to fit properly in its new list
  // the same we we would build the html from rails
  if (checked) {
    parent.prependTo($tabContent.find(amBehavior('available-list')))
    usedCounteEl.html(usedTemplatesCount - 1)

    if (usedTemplatesCount === 1) {
      $addedList.find(amBehavior('placeholder-message')).removeClass('hidden')
    }
  } else {
    if (usedTemplatesCount === 0) {
      $addedList.find(amBehavior('placeholder-message')).addClass('hidden')
    }

    parent.prependTo($addedList)
    usedCounteEl.html(usedTemplatesCount + 1)
  }

  return false
})

$(document).on('turbolinks:load', function () {
  $(document).off('click', "[data-behavior~='market-card-tab-label']")
  $(document).on(
    'click',
    "[data-behavior~='market-card-tab-label']",
    function (e) {
      e.preventDefault()
      $("[data-behavior~='market-card-tab-label']").removeClass('active')
      $(this).addClass('active')

      const selectedType = $(this).data('type')

      $('#selected_card_type').val(selectedType)

      $("[data-behavior~='market-card-tab-content']").each(function () {
        // console.log($(this).data("type"), selectedType, $(this).data("type") == selectedType)
        if ($(this).data('type') === selectedType) {
          $(this).show()
        } else {
          $(this).hide()
        }
      })
    }
  )
})
